// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__27rGt","description":"MealItem_description__1aUvl","price":"MealItem_price__2hcdi","pricePart":"MealItem_pricePart__3HuO_"};